import { Reveal } from "@/components/motion/Reveal";

// Consistent section eyebrow + heading block with the upward-arrow motif.
export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = "left",
  light = false,
  className = "",
}) {
  const alignCls = align === "center" ? "text-center items-center mx-auto" : "text-left items-start";
  return (
    <Reveal className={`flex flex-col ${alignCls} ${align === "center" ? "max-w-3xl" : "max-w-2xl"} ${className}`}>
      {eyebrow && (
        <div className={`mb-4 flex items-center gap-2.5 ${align === "center" ? "justify-center" : ""}`}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" className="text-brand">
            <path d="M4 14 L14 4 M14 4 H7 M14 4 V11" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <span className={`tech-tag ${light ? "text-brand-light" : "text-brand"}`}>{eyebrow}</span>
        </div>
      )}
      <h2 className={`font-heading text-3xl font-extrabold tracking-tight sm:text-4xl lg:text-[2.75rem] lg:leading-[1.1] ${light ? "text-white" : "text-navy"}`}>
        {title}
      </h2>
      {description && (
        <p className={`mt-5 text-base leading-relaxed sm:text-lg ${light ? "text-slate-300" : "text-slate-600"}`}>
          {description}
        </p>
      )}
    </Reveal>
  );
}
